import gql from 'graphql-tag';
import { SUBJECT_FRAGMENT, TRACKER_FRAGMENT } from './fragments';

export const measurementsQuery = gql`
  query MeasurementsQuery($input: MeasurementsQueryInput!) {
    measurements(input: $input) {
      id
      value
      notedAt
      subject {
        id
        name
        slug
      }
      tracker {
        id
        name
        slug
        type
      }
    }
  }
`;
